const settings = {
  API_ADDRESS: "https://api.open.skillsoft.com.br",
  API_ADDRESS_DEV: "http://localhost:8000",
  AMBIENTE_DEV: false,
};

export default settings;
